import React from 'react'
import { Box, Button, FormControl, FormControlLabel, FormLabel, Grid, TextField } from '@mui/material'
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const AntSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'rgb(30,60,114)',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

const PermissionElevationRequestForm = ({
    userDetails,
    handleFormData,
    permissionList,
    handleSwitchChange,
    setMessage,
    message
}) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
        <Grid container>
            <Grid item sm={5.5} xs={12} sx={{mb:1, mr:2}}>
                <FormControl fullWidth >
                    <FormLabel id="file-select-label">Email Address 12</FormLabel>
                    <TextField
                        disabled
                        id="email"
                        fullWidth
                        name="email_address"
                        value={userDetails?.email} 
                        sx={{backgroundColor:'#F9F9F9'}} 
                    />
                </FormControl>
            </Grid>
            <Grid item sm={5.5} xs={12} sx={{ mb:1, mr:2}}>
                <FormControl fullWidth>
                    <FormLabel id="file-select-label">Current Role</FormLabel> 
                    <TextField
                        disabled
                        id="current_role"
                        fullWidth
                        name="current_role"
                        value={userDetails?.rolename} 
                        sx={{backgroundColor:'#F9F9F9'}} 
                    />
                </FormControl> 
            </Grid>   
            <Grid item sm={11.2} xs={12} sx={{ mb:1}}>
                <FormControl fullWidth>
                    <FormLabel id="file-select-label">Message</FormLabel> 
                    <TextField 
                      id="message" 
                      name="message"
                      multiline
                      rows={3}
                      fullWidth
                      sx={{paddingBottom:2}}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                </FormControl> 
            </Grid> 
            <Grid item sm={5.5} xs={12} sx={{ mb:1, mr:2}}>
                <FormControl fullWidth>
                    <FormLabel id="demo-simple-select-standard-label">Current Permissions</FormLabel>
                    { userDetails?.permissions?.map((permission,index) => (
                        <FormControlLabel sx={{pb:1.5,pl:1,pt:0.5}} value={index}  control={ 
                            <>
                                <AntSwitch
                                    key={permission.id}
                                    checked={true}
                                    value={permission.id || ''}
                                    inputProps={{ 'aria-label': 'controlled' }} 
                                    
                                />
                                <label style={{paddingLeft:'16px'}}>{permission.permission_name}</label>
                            </>
                        }/>
                    ))}
                </FormControl>
            </Grid> 
            
            <Grid item sm={5.5} xs={12} sx={{ mb:1, mr:2}}>
                <FormControl fullWidth>
                    <FormLabel id="demo-simple-select-standard-label">Request Permissions</FormLabel>
                    { permissionList?.map((permission,index) => {
                      return (
                        <FormControlLabel sx={{pb:1.5,pl:1,pt:0.5}} value={index}  control={ 
                            <>
                                <AntSwitch
                                    key={permission.id}
                                    checked={permission?.checked}
                                    value={permission.id}
                                    inputProps={{ 'aria-label': 'controlled' }} 
                                    onChange={handleSwitchChange(permission.id)}
                                />
                                <label style={{paddingLeft:'16px'}}>{permission.permission_name}</label>
                            </>
                        }/>
                      )
                    })}
                </FormControl>
            </Grid>    
                
            <Grid item xs={12}> 
                <Button  
                    sx={{mr:1}}
                    variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleFormData}
                >Submit</Button>
            </Grid>
        </Grid>
    </Box>
  )
}

export default PermissionElevationRequestForm